import React from "react";

import { IgRadio, IgTypography } from "@intelligems/ig-theme";
import { FormControlLabel, Grid, RadioGroup } from "@mui/material";

interface PlacementOnPageProps {
  placement: string;
  onPlacementChange: (placement: string) => void;
  disabled?: boolean;
}

export const PlacementOnPage = ({
  placement,
  onPlacementChange,
  disabled,
}: PlacementOnPageProps) => {
  const placementOptions = [
    { value: "top-left", label: "Top left" },
    { value: "top-right", label: "Top right" },
  ];

  return (
    <Grid item container direction="column" spacing={3}>
      <Grid item>
        <IgTypography fontWeight="600" variant={"body1"}>
          Placement on page
        </IgTypography>
      </Grid>
      <Grid item>
        <RadioGroup
          value={placement}
          onChange={(e) => onPlacementChange(e.target.value)}
          row
        >
          {placementOptions.map((option) => (
            <FormControlLabel
              disabled={disabled}
              key={option.value}
              value={option.value}
              control={<IgRadio disabled={disabled} size="small" />}
              label={
                <IgTypography variant={"body1"}>{option.label}</IgTypography>
              }
            />
          ))}
        </RadioGroup>
      </Grid>
    </Grid>
  );
};
